import React, { useEffect, useRef } from 'react';
import { Booking } from '../components/Booking';
import { Countdown } from '../components/Countdown';
import { audioManager } from '../lib/audioManager';

const BOOKING_AUDIO_URL = process.env.REACT_APP_BOOKING_AUDIO_URL;

export const BookingPage = () => {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = new Audio(BOOKING_AUDIO_URL);
    audio.loop = false;
    audio.volume = 0.5;
    audioRef.current = audio;

    const stopSelf = () => {
      audio.pause();
      audioManager.clearNowPlaying(stopSelf);
    };
    audioManager.register(stopSelf);
    audioManager.requestPlayback(stopSelf, {
      title: 'Booking Ambiance',
      subtitle: 'Brooksgordon',
      audio: audio,
    });
    audio.play().catch(() => {});

    return () => {
      audioManager.unregister(stopSelf);
      audio.pause();
      audio.src = '';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-teal-950 to-gray-900 pt-24">
      <div className="container mx-auto px-4 lg:px-8 py-8">
        <Countdown />
      </div>
      <Booking />
    </div>
  );
};